module.exports = __webpack_public_path__ + "img/B1.9e088cb0.svg";